// @flow
import React from 'react';
import classnames from 'classnames';
import { pluralizeLabel } from 'Utils/label/labelUtils';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { t } from 'Src/i18n';

type Props = {
  extendedDataset?: boolean,
  adults: number,
  kids: number,
};

export const AttendeesSummary = ({ adults, extendedDataset = false, kids }: Props) => {
  return (
    <div
      className={classnames('PackagePriceSummary-section', {
        'PackagePriceSummary-section--extended': extendedDataset,
      })}
    >
      <Icon
        color={COLORS.BLUE}
        name={ICONS.USERS}
        className="PackagePriceSummary-icon"
        width="1.875rem"
        hasRtl
      />
      <span>
        <div className="PackagePriceSummary-guestsItem" key="adults">
          <span className="PackagePriceSummary-guestsNumber">{adults}</span>
          {` ${pluralizeLabel(t('booking.common.adult'), t('booking.common.adults'), adults)}`}
        </div>
        {kids > 0 ? (
          <div className="PackagePriceSummary-guestsItem" key="children">
            <span className="PackagePriceSummary-guestsNumber">{kids}</span>
            {` ${pluralizeLabel(t('booking.common.child'), t('booking.common.children'), kids)}`}
          </div>
        ) : null}
      </span>
    </div>
  );
};
